export function arrayToMap<T>(array: readonly T[],
                              keySelector: (t: T) => string): { [index: string]: T };
export function arrayToMap<T>(array: readonly T[],
                              keySelector: (t: T) => number): { [index: number]: T };
export function arrayToMap<T, V>(array: readonly T[],
                                 keySelector: (t: T) => string,
                                 valueSelector: (t: T) => V): { [index: string]: V };
export function arrayToMap<T, V>(array: readonly T[],
                                 keySelector: (t: T) => number,
                                 valueSelector: (t: T) => V): { [index: number]: V };
export function arrayToMap<T, V>(array: readonly T[],
                                 keySelector: (t: T) => string | number,
                                 valueSelector?: (t: T) => V): any {
  let result: { [index: string]: any } = {};
  if (valueSelector === undefined) {
    for (let x of array)
      result[keySelector(x)] = x;
    return result;
  }
  for (let x of array)
    result[keySelector(x)] = valueSelector(x);
  return result;
}
